export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-primary-500 to-accent-600 rounded-2xl overflow-hidden relative">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-64 h-64 bg-background-50 rounded-full -translate-y-1/2 translate-x-1/3"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-background-50 rounded-full translate-y-1/2 -translate-x-1/3"></div>
            </div>

            <div className="relative px-6 md:px-10 py-12 md:py-16 flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
                  有料要爆？联系我们
                </h2>
                <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-lg">
                  如果你掌握第一手911吃瓜黑料最新事件信息，欢迎通过以下方式联系我们。我们承诺严格保护爆料人隐私，让你的声音被更多人听到。
                </p>
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-4">
                <div className="flex items-center gap-3 bg-background-50/15 backdrop-blur-sm rounded-lg px-5 py-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-background-50/20 rounded-full">
                    <i className="ri-mail-line text-lg text-background-50"></i>
                  </div>
                  <div>
                    <div className="text-xs text-background-50/60">爆料邮箱</div>
                    <div className="text-sm font-medium text-background-50">tips@911baoliao.com</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-background-50/15 backdrop-blur-sm rounded-lg px-5 py-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-background-50/20 rounded-full">
                    <i className="ri-wechat-line text-lg text-background-50"></i>
                  </div>
                  <div>
                    <div className="text-xs text-background-50/60">微信公众号</div>
                    <div className="text-sm font-medium text-background-50">911爆料网</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}